"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.option = void 0;
var t = __importStar(require("io-ts"));
var None = t.strict({
    _tag: t.literal('None')
}, 'None');
var someLiteral = t.literal('Some');
/**
 * @since 0.5.0
 */
function option(codec, name) {
    if (name === void 0) { name = "Option<" + codec.name + ">"; }
    return t.union([
        None,
        t.strict({
            _tag: someLiteral,
            value: codec
        }, "Some<" + codec.name + ">")
    ], name);
}
exports.option = option;
